import { IBenefitDTO } from '../../dto/benefits/benefit.dto';
import { IBenefitsDTO } from '../../dto/benefits/benefits.dto';

const benefitDTOs: IBenefitDTO[] = [
  {
    title: $localize`:@@page-reel-downloader-content-benefits-section-option-0-title:Simple and user-friendly`,
    value: $localize`:@@page-reel-downloader-content-benefits-section-option-0-value:All you need to do is copy the URL of the Instagram reels video you want to download and paste it into our Instagram reels download tool. No technical skills are required! The process is straightforward, making it easy for anyone to use.`,
  },
  {
    title: $localize`:@@page-reel-downloader-content-benefits-section-option-1-title:No account required`,
    value: $localize`:@@page-reel-downloader-content-benefits-section-option-1-value:Skip the hassle of creating an account or logging in. With our tool, you can immediately download Instagram reels without additional steps. We value your privacy and make the download process seamless.`,
  },
  {
    title: $localize`:@@page-reel-downloader-content-benefits-section-option-2-title:High-quality downloads`,
    value: $localize`:@@page-reel-downloader-content-benefits-section-option-2-value:Want to download Instagram reels in the highest quality? Videos downloaded from our tool retain their original resolution, whether standard or high definition. Our service ensures the best quality possible.`,
  },
  {
    title: $localize`:@@page-reel-downloader-content-benefits-section-option-3-title:Instant download access`,
    value: $localize`:@@page-reel-downloader-content-benefits-section-option-3-value:There’s no waiting time — as soon as you hit download, your reels will be ready for you to enjoy instantly. No delays, just quick and easy access.`,
  },
];

export const benefitsDTO: IBenefitsDTO = {
  title: $localize`:@@page-reel-downloader-content-benefits-section-title:Why choose our Instagram reels downloader?`,
  benefits: benefitDTOs,
};
